<script setup lang="ts">
defineProps({
  mission: Object|null,
})
</script>

<template>
  <UPageCard :ui="{root: 'h-80 hover:ring-gray-300 hover:dark:ring-gray-700 hover:shadow-lg hover:bg-white', container: 'gap-2 sm:p-4 lg:flex max-w-full'}" :to="mission ? mission.url : null">
    <USkeleton class="h-4 w-[80%]" v-if="!mission"/>
    <USkeleton class="h-4 w-[50%]" v-if="!mission"/>
    <USkeleton class="h-4 w-[60%]" :ui="{background: 'bg-secondary'}" v-if="!mission"/>
    <USkeleton class="h-3 w-[90%]" v-if="!mission"/>
    <USkeleton class="h-3 w-[75%]" v-if="!mission"/>
    <USkeleton class="h-3 w-[85%]" v-if="!mission"/>
    <USkeleton class="h-3 w-[45%]" v-if="!mission"/>
    <USkeleton class="h-3 w-[75%]" v-if="!mission"/>
    <USkeleton class="h-3 w-[25%]" v-if="!mission"/>
    <div class="flex-1" v-if="!mission"></div>
    <USkeleton class="h-4 w-[95%]" v-if="!mission"/>
    <div class="flex items-center h-10">
      <p class="font-bold text-lg line-clamp-2 leading-tight" v-if="mission">{{mission.title}}</p>
    </div>

    <p class="text-secondary font-semibold">
				<span v-if="mission?.publisher && !mission.activity_type">
					Mission {{mission.publisher.name}}
				</span>
      <span v-if="mission?.activity_type" class="flex items-center gap-1 -x-1"><UIcon :name="getIcon(mission.activity_type.slug)" />{{  mission.activity_type.name }}</span>
    </p>
    <USeparator v-if="mission?.type == 'punctual'" />
    <div class="text-sm flex flex-row items-center text-gray-500" v-if="mission?.type == 'punctual'">
        <div class="flex flex-1 items-center gap-1 -x-1 overflow-hidden gradient-overlay-right">
          <UIcon name="i-ph-calendar-check-duotone" class="flex-shrink-0" /> <span class="flex-shrink-0">{{mission.date_txt}}</span>
        </div>
      <div v-if="mission.places" class="font-semibold text-info flex-shrink-0">
        <span v-if="mission.remaining_places">{{`${mission.remaining_places} place${mission.remaining_places > 1 ? 's' : ''} restante${mission.remaining_places > 1 ? 's' : ''}`}}</span>
        <span v-else>complet</span>
      </div>
    </div>
    <USeparator v-if="mission?.type == 'punctual'" />
    <div class="flex-1 overflow-hidden gradient-overlay-bottom">
      <p class="text-sm" v-if="mission" aria-hidden="true">{{mission.description}}</p>
    </div>
    <div class="text-sm flex flex-row items-center text-gray-500 overflow-hidden gradient-overlay-right" v-if="mission">
        <span v-if="!mission.remote" class="flex items-center gap-1 -x-1 flex-shrink-0">
          <UIcon name="i-ph-map-pin-duotone" /> {{mission.location.public_value ? mission.location.public_value : mission.location_txt}}
        </span>
      <UTooltip v-if="mission.remote" text="Cette mission peut être réalisée à distance, en télébénévolat">
        <span class="flex items-center gap-1 -x-1 flex-shrink-0"><UIcon name="i-ph-house-duotone" /> À distance</span>
      </UTooltip>
      <span v-if="mission.type == 'one-shot' || mission.type == 'punctual'" class="flex items-center gap-1 -x-1 flex-shrink-0">
					<span class="mx-2">&bull;</span>
					<UIcon name="i-ph-calendar-check-duotone" /> Ponctuel
				</span>
      <span v-if="mission?.organization.domain" class="flex items-center gap-1 -x-1 flex-shrink-0">
					<span class="mx-2">&bull;</span>
					<UIcon :name="getIcon(mission.organization.domain.slug)" /> {{mission.organization.domain.name}}
				</span>
      <span v-if="mission.activity_type && mission.publisher?.id" class="flex-shrink-0">
					<span class="mx-2">&bull;</span>
					Mission {{mission.publisher.name}}
				</span>
    </div>
    <USeparator />
    <div class="flex flex-row items-center gap-4">
      <UAvatar size="md" class="rounded-none squircle" :src="mission?.organization.avatar_url ? mission.organization.avatar_url : '/im/organization-avatar-default.png'" alt=""/>
      <p class="font-semibold leading-tight line-clamp-2" v-if="mission"> {{ mission.organization.name }}</p>
      <USkeleton class="h-4 w-[55%]" v-if="!mission"/>
    </div>
  </UPageCard>
</template>